/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Resolution_FailedInputs */

const vi_einvoice_err_resolution_failed = /** @type {(inputs: Einvoice_Err_Resolution_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa lưu được. Vui lòng thử lại.`)
};

/**

* @param {Einvoice_Err_Resolution_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_resolution_failed = /** @type {((inputs?: Einvoice_Err_Resolution_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Resolution_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_resolution_failed(inputs)
});